export enum ReducerAction {
  Set = 'Set',
  Reset = 'Reset',
}
